var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0291 9.19936C19.0291 8.45937 18.9676 7.91937 18.8347 7.35938H10.1875V10.6993H15.2632C15.1609 11.5294 14.6083 12.7794 13.3803 13.6193L13.3631 13.7311L16.0971 15.8009L16.2865 15.8194C18.0262 14.2494 19.0291 11.9393 19.0291 9.19936Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1885 18.0012C12.6752 18.0012 14.7628 17.2012 16.2876 15.8212L13.3813 13.6212C12.6036 14.1512 11.5598 14.5212 10.1885 14.5212C7.75304 14.5212 5.68592 12.9512 4.94905 10.7812L4.84104 10.7902L1.99812 12.9402L1.96094 13.0412C3.47545 15.9812 6.58639 18.0012 10.1885 18.0012Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94705 10.7779C4.75262 10.2179 4.6401 9.61785 4.6401 8.99788C4.6401 8.37784 4.75262 7.77786 4.93682 7.21787L4.93167 7.0986L2.05312 4.91406L1.95894 4.95784C1.33473 6.17785 0.976562 7.54788 0.976562 8.99788C0.976562 10.4479 1.33473 11.8178 1.95894 13.0378L4.94705 10.7779Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1885 3.47998C11.918 3.47998 13.0845 4.20997 13.7497 4.82001L16.349 2.34C14.7526 0.890004 12.6752 0 10.1885 0C6.58639 0 3.47545 2.01998 1.96094 4.95996L4.93882 7.21999C5.68592 5.05 7.75303 3.47998 10.1885 3.47998Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.fc5815fe52930a7516fb9e7fa9bc98e3.svg";
export { ForwardRef as ReactComponent };